import React, { useMemo } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setAccountOption } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';

function SetAccountType() {
  const dispatch = useDispatch();

  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.clientsFilter
  );

  function setAccount(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setAccountOption(value));
  }

  const GenerateOptions = useMemo(() => {
    switch (clientsFilterState.ownership) {
      case '1':
        return (
          <>
            <option key={1} value="global">
              {1} - Contas de Titularidade Fidúcia
            </option>
            <option key={2} value="consignada">
              {2} - Consignada
            </option>
            <option key={3} value="escrow">
              {3} - Escrow
            </option>
          </>
        );

      case '2':
        return (
          <>
            <option key={1} value="global">
              {1} - Todas
            </option>
            <option key={2} value="consignada">
              {2} - Consignada
            </option>
            <option key={3} value="escrow">
              {3} - Escrow
            </option>
          </>
        );

      default:
        return (
          <>
            <option key={1} value="global">
              Todas
            </option>
            <option key={2} value="consignada">
              {1} - Consignada
            </option>
            <option key={3} value="escrow">
              {2} - Escrow
            </option>
            <option key={4} value="pf">
              {3} - Movimento - Pessoa Física
            </option>
            <option key={5} value="pj">
              {4} - Movimento - Pessoa Jurídica
            </option>
          </>
        );
    }
  }, [clientsFilterState.ownership]);

  return (
    <Wrapper.Default flexDirection="row" isActive>
      <span>Conta:</span>
      <Form.Control
        as="select"
        style={{ width: '11rem', margin: '0 1rem 0 0.25rem' }}
        value={clientsFilterState.account}
        onChange={(event) => setAccount(event)}>
        {GenerateOptions}
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetAccountType;
